export enum SponsorChallenges {
  SPONSOR_CHALLENGE_1 = 'HoloRay',
  SPONSOR_CHALLENGE_2 = 'Athena AI',
  SPONSOR_CHALLENGE_3 = 'Gumloop',
  SPONSOR_CHALLENGE_4 = 'National Bank',
}

export default SponsorChallenges;